export function profileDisplayStatus(u) {
  return u.status || (u.auth_subject ? 'invited' : u.invite_status === 'pending' ? 'invited' : 'named');
}

export function canSendProfileInvite(u) {
  if (u.auth_subject) return false;
  if (u.invite_status === 'pending') return true;
  return profileDisplayStatus(u) !== 'invited';
}

export function inviteActionLabel(u) {
  return u?.invite_status === 'pending' ? 'Resend invite' : 'Send invite';
}

/** Short follow-up after invite — email is sent by invite-user edge function. */
export function inviteInstructions(email, emailSent = true) {
  const addr = String(email || '').trim() || 'their email address';
  if (emailSent) {
    return `They can use the Auth0 sign-in link sent to ${addr}.`;
  }
  const appUrl = typeof window !== 'undefined' ? window.location.origin : 'your Transformax app URL';
  return `Email could not be sent — ask them to open ${appUrl}/auth and sign in with ${addr} via Auth0.`;
}

export function subTeamsForTeam(subTeams, teamId, orgId, activeOnly = true, includeSubTeamId = null) {
  if (!teamId) return [];
  const teamKey = String(teamId);
  let list = (subTeams || []).filter(
    (t) => t.organisation_id === orgId && String(t.team_id) === teamKey,
  );
  if (activeOnly) {
    list = list.filter((x) => x.is_active !== false || (includeSubTeamId && String(x.id) === String(includeSubTeamId)));
  }
  return list;
}

export function patchTeamChange(teamId, currentSubTeamId, subTeams, orgId) {
  const patch = { team_id: teamId };
  if (!teamId) {
    patch.sub_team_id = '';
  } else if (currentSubTeamId) {
    const ok = subTeamsForTeam(subTeams, teamId, orgId).some((st) => st.id === currentSubTeamId);
    if (!ok) patch.sub_team_id = '';
  }
  return patch;
}
